<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h4 mat-dialog-title>Liste des mots pour non prise en compte lors de la règle de matching société eFac vs
                société métadonnée</h4>
            <hr>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="section container-fluid justify-content-center">
                <div class="row">
                    <div class="col">
                        <div class="form-group-container form-group mx-0 row">
                            <label class="col-xs-12 col-md-3 my-auto pl-0" for="keywords">Mot clé</label>
                            <div class="col-xs-12 col-md-8 px-0">
                                <input class="form-control" #newKeyword>
                            </div>
                            <div class="col-1"> <button type="button" class="btn btn-action" (click)="onAdd()"
                                    tooltip="Ajouter">
                                    <span class="material-icons">add</span>
                                </button></div>
                        </div>
                    </div>
                </div>
                <div class="row keywords-content">
                    <div class="col">
                        <div class="keyword row" *ngFor="let keyword of keywords">
                            <div class="col">
                                {{keyword}}
                            </div>
                            <div class="col-1">
                                <span class="material-icons" tooltip="Supprimer"
                                    (click)="onDelete(keyword)">delete_forever
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row modal-actions">
        <div class="col align-items-end modal-footer">
            <button type=" button" class="btn btn-secondary" data-dismiss="modal"
                (click)="close(false);">Annuler</button>
            <button type="submit" class="btn btn-secondary" (click)="onSubmit()">Enregistrer</button>
        </div>
    </div>
</div>